import { useState } from "react";
import { categoryIndex } from "@/mocks/home";

export default function CategoryIndex() {
  const [active, setActive] = useState(categoryIndex[0].name);
  const current = categoryIndex.find((c) => c.name === active) ?? categoryIndex[0];

  return (
    <section id="categories" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-widest text-primary-600">
              CATEGORY INDEX
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              分类索引 · 快速定位
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              按话题分区整理，想找哪一类直接点开，比一页页翻更快。
            </p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="text-xs text-foreground-500">当前查看</p>
              <p className="mt-1.5 font-heading text-xl font-bold text-foreground-950">
                {current.name}
              </p>
              <p className="mt-3 flex items-baseline gap-1.5">
                <span className="font-heading text-3xl font-black text-primary-600">
                  {current.count}
                </span>
                <span className="text-xs text-foreground-500">条已归档</span>
              </p>
              <p className="mt-4 border-t border-background-200 pt-4 text-xs leading-relaxed text-foreground-500">
                该分区内容会随热度变化持续补充，点击右侧任意标签即可切换查看其他分类的收录数量。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-wrap gap-2.5">
              {categoryIndex.map((c) => {
                const isActive = c.name === active;
                return (
                  <button
                    key={c.name}
                    type="button"
                    onClick={() => setActive(c.name)}
                    className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition-colors whitespace-nowrap cursor-pointer ${
                      isActive
                        ? "border-primary-500 bg-primary-500 text-background-50 dark:text-foreground-950"
                        : "border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-foreground-950"
                    }`}
                  >
                    {c.name}
                    <span
                      className={`rounded-full px-1.5 text-xs ${
                        isActive
                          ? "bg-background-50/25 text-background-50 dark:text-foreground-950"
                          : "bg-background-200 text-foreground-500"
                      }`}
                    >
                      {c.count}
                    </span>
                  </button>
                );
              })}
            </div>

            <div className="mt-6 rounded-lg border border-dashed border-background-300 bg-background-100/60 p-5">
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className="ri-bookmark-3-line text-base"></i>
                </span>
                <p className="text-sm leading-relaxed text-foreground-600">
                  索引仅作为内容归类的入口，所有分区共用同一套入口地址与链接，收藏一次即可长期浏览，无需为每个分类单独记网址。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}